export enum AddresTypeEnum{
   formal = "formal",
   correspondence = "correspondence",
}
